import * as FileSaver from 'file-saver';

export class FileHelper {
  public static saveAsJson(content: any, filename: string) {
    const blob = new Blob([JSON.stringify(content, null, 2)], { type: 'text/json;charset=utf-8' });
    FileSaver.saveAs(blob, `${filename}.json`);
  }

  public static saveBlobAsJson(blob: Blob, filename: string) {
    FileSaver.saveAs(blob, `${filename}.json`);
  }

  public static saveAsTxt(content: any, filename: string) {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, `${filename}.txt`);
  }

  public static saveBlobAsTxt(blob: Blob, filename: string) {
    FileSaver.saveAs(blob, `${filename}.txt`);
  }

  public static saveAsCsv(content: any, filename: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, `${filename}.csv`);
  }

  public static saveBlobAsCsv(blob: Blob, filename: string) {
    FileSaver.saveAs(blob, `${filename}.csv`);
  }

  // application/pdf behavior : pdf viewer opens in current tab & no download is performed automatically
  // application/octet-stream behavior : pdf viewer opens in new tab & file is automatically downloaded

  public static saveAsPdf(content: any, filename: string) {
    const blob = new Blob([content], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, `${filename}.pdf`);
  }

  public static saveBlobAsPdf(blob: Blob, filename: string) {
    FileSaver.saveAs(blob, `${filename}.pdf`);
  }

  public static displayAsPdf(content: any) {
    const blob = new Blob([content], { type: 'application/pdf' });
    window.open(URL.createObjectURL(blob), '_blank');
  }

  public static displayBlobAsPdf(blob: Blob) {
    window.open(URL.createObjectURL(blob), '_blank');
  }

  public static saveAsZip(content: any, filename: string) {
    const blob = new Blob([content], { type: 'octet/stream' });
    FileSaver.saveAs(blob, `${filename}.zip`);
  }

  public static saveBlobAsZip(blob: Blob, filename: string) {
    FileSaver.saveAs(blob, `${filename}.zip`);
  }
}
